// src/components/AdminLayout.tsx
import React from "react";
import { AppBar, Toolbar, Box, Typography, Button, IconButton, Tooltip, Container } from "@mui/material";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import GraphicEqRoundedIcon from "@mui/icons-material/GraphicEqRounded";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const NAV_ITEMS = [
  { label: "音乐", path: "/music" },
  { label: "艺术家", path: "/artist" },
  { label: "上传音乐", path: "/upload" },
];

interface AdminLayoutProps {
  title: string;
  actions?: React.ReactNode;
  children: React.ReactNode;
}

const AdminLayout: React.FC<AdminLayoutProps> = ({ title, actions, children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout } = useAuth();

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "background.default" }}>
      <AppBar position="static">
        <Toolbar sx={{ gap: 0.5 }}>
          <GraphicEqRoundedIcon sx={{ color: "primary.light", mr: 1 }} />
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Luna
          </Typography>
          <Box component="nav" sx={{ display: "flex", gap: 0.5 }}>
            {NAV_ITEMS.map((item) => {
              const active = location.pathname === item.path;
              return (
                <Button
                  key={item.path}
                  onClick={() => navigate(item.path)}
                  sx={{
                    color: active ? "primary.light" : "rgba(245,243,238,0.75)",
                    borderBottom: "2px solid",
                    borderColor: active ? "primary.light" : "transparent",
                    borderRadius: 0,
                    px: 1.5,
                    py: 2,
                    "&:hover": { borderColor: "rgba(245,243,238,0.35)" },
                  }}
                >
                  {item.label}
                </Button>
              );
            })}
          </Box>
          <Tooltip title="退出登录">
            <IconButton onClick={handleLogout} aria-label="退出登录" sx={{ ml: 1, color: "rgba(245,243,238,0.6)" }}>
              <LogoutRoundedIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Toolbar>
      </AppBar>

      <Container maxWidth="lg" sx={{ py: 4 }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: 2,
            mb: 3,
          }}
        >
          <Typography variant="h5" component="h1">
            {title}
          </Typography>
          {actions && <Box sx={{ display: "flex", gap: 1 }}>{actions}</Box>}
        </Box>
        {children}
      </Container>
    </Box>
  );
};

export default AdminLayout;
